import {
  FormControl,
  TextField,
  Box,
  Button,
  MenuItem,
  InputLabel,
  Select,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import propTypes from 'prop-types';

export const TextAreaComponent = ({
  input,
  index,
  setLastFocus,
  setTmpMessage,
  tmpMessage,
  classes,
}) => {
  return (
    <FormControl fullWidth>
      <TextField
        className={classes.textArea}
        placeholder={input.label}
        name={input.propName}
        onFocus={() => setLastFocus(input.propName)}
        multiline
        inputProps={{ className: classes.message }}
        value={tmpMessage[input.propName] || ''}
        onChange={(e) => {
          setTmpMessage({
            ...tmpMessage,
            [input.propName]: e.target.value,
          });
        }}
        rows={6}
        variant="outlined"
        spellCheck="false"
      />
    </FormControl>
  );
};

TextAreaComponent.propTypes = {
  input: propTypes.object,
  index: propTypes.number,
  setLastFocus: propTypes.func,
  setTmpMessage: propTypes.func,
  tmpMessage: propTypes.object,
  classes: propTypes.object,
};

export const DefaultTextComponent = ({ input, setLastFocus, setTmpMessage, tmpMessage }) => {
  return (
    <FormControl fullWidth sx={{ mt: 2 }}>
      <TextField
        required
        label={input.label}
        name={input.propName}
        onFocus={() => setLastFocus(input.propName)}
        value={tmpMessage[input.propName] || ''}
        onChange={(e) => {
          setTmpMessage({
            ...tmpMessage,
            [input.propName]: e.target.value,
          });
        }}
        variant="outlined"
        spellCheck="false"
      />
    </FormControl>
  );
};

DefaultTextComponent.propTypes = {
  input: propTypes.object,
  setLastFocus: propTypes.func,
  setTmpMessage: propTypes.func,
  tmpMessage: propTypes.object,
};

export const SelectComponent = ({ input, index, setTmpMessage, tmpMessage }) => {
  return (
    <FormControl key={`${input.propName}${index}`} sx={{ mr: 2, minWidth: '200px' }}>
      <InputLabel id="select">{input.label}</InputLabel>
      <Select
        labelId="select"
        id="select"
        value={
          tmpMessage[input.propName] === 0 || tmpMessage[input.propName]
            ? tmpMessage[input.propName]
            : -1
        }
        label={input.label}
        onChange={(e) => {
          setTmpMessage({
            ...tmpMessage,
            [input.propName]: e.target.value,
          });
        }}
      >
        <MenuItem key={-1} value={-1}>
          No cambiar
        </MenuItem>
        {input &&
          input.values &&
          input.values.map((e) => (
            <MenuItem key={e.value} value={e.value}>
              {e.label}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

SelectComponent.propTypes = {
  input: propTypes.object,
  index: propTypes.number,
  setTmpMessage: propTypes.func,
  tmpMessage: propTypes.object,
};

export const ButtonComponent = ({ input, index, classes, handleSuccess, handleDanger }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginLeft: '10px',
      }}
    >
      <Button
        key={`${input.propName}${index}`}
        variant="contained"
        color={input.isSuccess ? 'primary' : 'secondary'}
        className={input.isSuccess ? classes.cancelButton : ''}
        sx={{ ml: index !== 0 ? 2 : 0, height: 'fit-content' }}
        onClick={(e) => {
          if (input.isSuccess) handleSuccess(e, input.label);
          else handleDanger(e, input.label);
        }}
      >
        {input.label}
      </Button>
    </Box>
  );
};

ButtonComponent.propTypes = {
  input: propTypes.object,
  index: propTypes.number,
  classes: propTypes.object,
  handleSuccess: propTypes.func,
  handleDanger: propTypes.func,
};

export const CheckboxComponent = ({ input, index, setTmpMessage, tmpMessage }) => {
  return (
    <FormControlLabel
      key={`${input.propName}${index}`}
      control={
        <Checkbox
          checked={!!tmpMessage[input.propName]}
          name={input.propName}
          onChange={(e) => {
            setTmpMessage({
              ...tmpMessage,
              [input.propName]: e.target.checked,
            });
          }}
        />
      }
      label={input.label}
    />
  );
};

CheckboxComponent.propTypes = {
  input: propTypes.object,
  index: propTypes.number,
  setTmpMessage: propTypes.func,
  tmpMessage: propTypes.object,
};
